export default __webpack_public_path__ + "static/media/search-EN.1f38b378.png";